module.exports = __webpack_public_path__ + "static/sc_16-bd0a482f968d914d4ca9bb9048fe0b52.jpg";